import { colors } from 'components/styles/variables';

interface Props {
  className?: string;
  isActive?: boolean;
}

const Bar = ({ className = '', isActive }: Props): JSX.Element => (
  <div className={`${isActive ? 'active' : ''} ${className}`}>
    <style jsx>{`
      div {
        position: relative;
        height: 3px;
        width: 100%;
        background-color: ${colors.ALR1};
        display: none;
        z-index: 1;
      }
      .active {
        display: block;
      }
    `}</style>
  </div>
);

export default Bar;
